<template>
    <div class="relative z-0 w-fit max-w-full p-[0.125rem] bg-secondary rounded-[6.25rem] overflow-hidden">
        <Transition name="fade">
            <button
                v-show="!filterBarPosStart"
                type="button"
                class="absolute z-1 top-[0.125rem] left-[0.125rem] w-[1.9375rem] h-[1.9375rem] rounded-full text-primary border border-primary bg-secondary box-border medium:hidden"
                @click.prevent="filterBarScroll('start')"
            >
                <span class="sr-only">
                    {{ $root.config.translations.general.scroll_to_start }}
                </span>
                <svg class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 rotate-180" width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current" fill d="M0.473697 13C0.349659 13 0.225621 12.95 0.130208 12.84C-0.0510785 12.6399 -0.0415372 12.3198 0.14929 12.1298L5.81687 6.48823L0.14929 0.856699C-0.0415372 0.666648 -0.0510785 0.356563 0.130208 0.156509C0.311494 -0.0435456 0.616818 -0.0535483 0.807645 0.136503L6.84734 6.13813C6.94275 6.22816 7 6.3682 7 6.49823C7 6.62827 6.94275 6.76831 6.84734 6.85833L0.798104 12.86C0.70269 12.95 0.588194 13 0.473697 13Z" />
                </svg>
            </button>
        </Transition>
        <ul
            ref="vendorFilterBar"
            class="relative z-0 flex items-center gap-x-[0.125rem] overflow-x-auto"
            @scroll="filterBarNextVisibility()"
        >
            <li
                v-for="(vendor, index) in vendorData"
                :key="index"
                class="shrink-0"
            >
                <button
                    type="button"
                    class="body-l pt-[0.125rem] px-4 pb-1 rounded-[6.25rem] [&.is-active]:text-secondary [&.is-active]:bg-primary"
                    :class="{'is-active': activeVendor === vendor.filter_value}"
                    @click.prevent="selectVendor(activeVendor, vendor.filter_value)"
                >
                    {{ vendor.filter_label }}
                </button>
            </li>
        </ul>
        <Transition name="fade">
            <button
                v-show="!filterBarPosEnd"
                type="button"
                class="absolute z-1 top-[0.125rem] right-[0.125rem] w-[1.9375rem] h-[1.9375rem] rounded-full text-primary border border-primary bg-secondary box-border medium:hidden"
                @click.prevent="filterBarScroll('end')"
            >
                <span class="sr-only">
                    {{ $root.config.translations.general.scroll_to_end }}
                </span>
                <svg class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current" fill d="M0.473697 13C0.349659 13 0.225621 12.95 0.130208 12.84C-0.0510785 12.6399 -0.0415372 12.3198 0.14929 12.1298L5.81687 6.48823L0.14929 0.856699C-0.0415372 0.666648 -0.0510785 0.356563 0.130208 0.156509C0.311494 -0.0435456 0.616818 -0.0535483 0.807645 0.136503L6.84734 6.13813C6.94275 6.22816 7 6.3682 7 6.49823C7 6.62827 6.94275 6.76831 6.84734 6.85833L0.798104 12.86C0.70269 12.95 0.588194 13 0.473697 13Z" />
                </svg>
            </button>
        </Transition>
    </div>
</template>

<script>
    export default {
        props: {
            activeVendor: {
                type: String,
                default () {
                    return '';
                }
            },
            vendorData: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        emits: [
            'selected-vendor'
        ],
        data () {
            return {
                filterBarPosEnd: false,
                filterBarPosStart: true
            }
        },
        mounted () {
            this.filterBarNextVisibility();
        },
        methods: {
            filterBarScroll (position) {
                let leftVal = 0;
                if (position === 'start') {
                    leftVal = 0;
                } else if (position === 'end') {
                    leftVal = this.$refs.vendorFilterBar.scrollWidth;
                }
                this.$refs.vendorFilterBar.scrollTo({
                    left: leftVal,
                    behavior: 'smooth'
                });
            },
            filterBarNextVisibility () {
                if (!this.$refs.vendorFilterBar) return;

                const { scrollWidth, clientWidth, scrollLeft } = this.$refs.vendorFilterBar;

                // Check if scroll area is at the end of the scrollable area
                if (Math.ceil(scrollLeft + clientWidth) < scrollWidth) {
                    this.filterBarPosEnd = false;
                } else {
                    this.filterBarPosEnd = true;
                }

                // Check if scroll area is at the start of the scrollable area
                if (scrollLeft > 0) {
                    this.filterBarPosStart = false;
                } else {
                    this.filterBarPosStart = true;
                }
            },
            selectVendor (oldVendor, newVendor) {
                this.$emit('selected-vendor', oldVendor, newVendor);
            }
        }
    };
</script>
